module.exports = __webpack_public_path__ + "img/noimage.5444bcc5.jpg";